import { ProductFieldBlok } from '../../types'
import { useProducts } from './useProducts'

export const useProduct = ({ id }: { id: string }): ProductFieldBlok => {
  const products = useProducts()
  const product = products.find(product => product.uuid === id)

  return product
}
